import React from 'react';
import { BrowserRouter } from 'react-router-dom';
import AppRoutes from './AppRoutes';
import Main from './components/Main';

const App: React.FC = () => {
  return (
    <Main></Main>
  );
};

export default App;